import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import DisbursementFormPresenter from "./DisbursementFormPresenter";
import DisbursementEarningTable from "./DisbursementTable/DisbursementEarningTable";
import DisbursementDeductionTable from "./DisbursementTable/DisbursementDeductionTable";
import { v4 as uuidv4 } from "uuid";

class DisbursementFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: "",
      name: "",
      employee: [],
      payrollCode: "",
      advanced: false,
      selectedType: "",
      other: "",
      objectID: "",
      earningObj: [],
      deductionObj: [],
      cash: false,
      earningData: [],
      deductionData: [],
    };
    this.presenter = new DisbursementFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "disbursement";
  }

  getStateSelectedType() {
    return this.state.selectedType;
  }

  async componentDidMount() {
    const { object } = this.state;
    this.presenter.componentDidMount();
    const emp = await findObjectUseCase().execute("employees");
    console.log("gydvgehdb", emp);
    const employee = emp.map((data) => {
      const surname = data.surname;
      const firstname = data.Firstname;
      return `${surname}, ${firstname}`;
    });
    // console.warn("IDDDDDDDD: ", this.getObjectId());
    if (this.getObjectId() === undefined) {
      const objectID = uuidv4();
      this.setState({ objectID });
    }
    this.setState({ employee });
  }

  async componentDidUpdate(prevProps, prevState) {
    const { object } = this.state;
    if (prevState.object !== object) {
      if (object.employee) {
        this.setState({
          selectedEmployee: object.employee,
          objectID: this.getObjectId(),
          username: object.username,
          payrollCode: object.payrollCode,
          selectedType: object.payment,
          other: object.other,
          cash: object.cash,
          subjAuthorithy: object.subjAuthorithy,
          suppDocuments: object.suppDocuments,
        });
      }

      const earnings = await findObjectUseCase().execute("earning");
      const deductions = await findObjectUseCase().execute("deduction");

      const earningData = earnings.filter(
        (item) => item.payrollCode === this.getObjectId()
      );
      const deductionData = deductions.filter(
        (item) => item.payrollCode === this.getObjectId()
      );
      this.setState({ earningData: earningData, deductionData: deductionData });
    }
  }

  handleSelectedEmployee = (selectedEmployee) => {
    this.setState({ selectedEmployee });
  };

  handleEmployeeChange = (employee) => {
    this.setState({ employee });
  };

  handleDisbursementNumChange = (payrollCode) => {
    this.setState({ payrollCode });
  };

  handlePaymentChange = (selectedType) => {
    this.setState({ selectedType });
  };

  handleOtherChange = (other) => {
    this.setState({ other });
  };

  earningData = (object) => {
    this.setState({ earningObj: object });
  };

  deductionData = (object) => {
    this.setState({ deductionObj: object });
  };

  setEarningName() {
    return this.state.name;
  }

  handleSubmit = async () => {
    const {
      selectedEmployee,
      payrollCode,
      fundCluster,
      selectedType,
      other,
      objectID,
      cash,
      subjAuthorithy,
      suppDocuments,
    } = this.state;
    const data = {
      cash,
      subjAuthorithy,
      suppDocuments,
      employee: selectedEmployee,
      payrollCode,
      payment: selectedType,
      other,
    };

    this.state.earningObj.forEach((item) => {
      // console.log("NEWEARNING", item);
      upsertUseCase().execute("earning", item);
    });

    this.state.deductionObj.forEach((item) => {
      upsertUseCase().execute("deduction", item);
    });

    if (objectID !== "") {
      const edit = {
        ...data,
        id: objectID,
      };
      await upsertUseCase().execute("disbursement", edit);
      this.presenter.showSuccess("Disbursement Updated ");
    } else {
      await upsertUseCase().execute("disbursement", data);
      this.presenter.showSuccess("New Disbursement Added");
    }
  };

  handleChildID(data) {
    this.setState({ objectID: data });
  }

  handleCheckBox(field) {
    this.setState({ [field]: !this.state[field] });
  }

  render() {
    const { object, employee, advanced } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>No schema</h1>;
    console.warn("OBEJCT: ", object);

    const selectedType = ["MDS Check", "Commercial Check", "ADA", "Others"];
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSubmit();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        // onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="p-0">
                          <label className="mb-2">
                            Employee <span className="text-danger">*</span>
                          </label>
                          <SearchSelect
                            required={true}
                            value={this.state.selectedEmployee}
                            onChange={this.handleSelectedEmployee}
                            options={employee.map((employee) => ({
                              label: employee,
                              value: employee,
                            }))}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            Payroll Code <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="payrollCode"
                            object={object}
                            onChange={this.handleDisbursementNumChange}
                            required={true}
                          />
                        </div>

                        <div className="p-0">
                          <label>Mode of Payment</label>
                          <SearchSelect
                            value={this.state.selectedType}
                            onChange={this.handlePaymentChange}
                            options={selectedType.map((selectedType) => ({
                              label: selectedType,
                              value: selectedType,
                            }))}
                          />
                        </div>
                        {this.state.selectedType === "Others" && (
                          <div className="p-0">
                            <label>If Others, Please specify </label>
                            <InputFactory
                              type="String"
                              field="other"
                              object={object}
                              onChange={this.handleOtherChange}
                            />
                          </div>
                        )}
                      </>
                    )}

                    <DisbursementEarningTable
                      objectID={this.state.objectID}
                      childData={this.state.earningData}
                      getObjectId={this.handleChildID.bind(this)}
                      earningData={this.earningData}
                    />

                    <DisbursementDeductionTable
                      objectID={this.state.objectID}
                      childData={this.state.deductionData}
                      getObjectId={this.handleChildID.bind(this)}
                      earningData={this.deductionData}
                    />

                    <label>Certified</label>
                    <div className="d-flex gap-3 ">
                      <label>
                        <input
                          style={{ accentColor: "#333" }}
                          object={object}
                          type="checkbox"
                          onChange={() => this.handleCheckBox("cash")}
                          checked={this.state.cash}
                          name="cash"
                        />{" "}
                        Cash Available
                      </label>
                      <label>
                        <input
                          style={{ accentColor: "#333" }}
                          object={object}
                          type="checkbox"
                          onChange={() => this.handleCheckBox("subjAuthorithy")}
                          checked={this.state.subjAuthorithy}
                          name="subjAuthorithy"
                        />{" "}
                        Subject to Authority to Debit Account (when applicable)
                      </label>
                    </div>
                  </div>
                  <label>
                    <input
                      style={{ accentColor: "#333" }}
                      object={object}
                      type="checkbox"
                      onChange={() => this.handleCheckBox("suppDocuments")}
                      checked={this.state.suppDocuments}
                      name="suppDocuments"
                    />{" "}
                    Supporting documents complete and amount claimed properly
                  </label>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                      // onClick={this.handleSubmit.bind(this)}
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(DisbursementFormPage);
